import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class IncotermService {

  constructor(private http: HttpClient) { }

  getAllIncoterms(): Observable<any> {
    return this.http.get(mainUrl + 'param-iconters')
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createIncoterm(form): Observable<any> {
    return this.http.post(mainUrl + 'param-iconter', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getIncotermById(id): Observable<any> {
    return this.http.get(mainUrl + 'param-iconter/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  updateIncoterm(id, form): Observable<any> {
    return this.http.put(mainUrl + 'param-iconter/' + id, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteIncoterm(id): Observable<any> {
    return this.http.delete(mainUrl + 'param-iconter/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
     });

    return headers;
  }
}